import {isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

import {toFinancialProductPreferenceCoordinates} from 'features/financial-products';

import {FinancialProductOffer} from '../../../api/types/onlineOfferTypes';
import {FinancialProductPreferenceOutbox} from '../FinancialProductPreferenceOutbox';

export const hasRebasedStoredSelection = (offer: FinancialProductOffer | Nullish) => {
  if (
    !isNotNil(offer?.selection) ||
    offer.availability !== 'UNAVAILABLE' ||
    !offer.unavailableReason?.startsWith('UNSUPPORTED_')
  ) {
    return false;
  }

  return !FinancialProductPreferenceOutbox.matchesCoordinates(
    {...offer.selection, productType: offer.productType},
    toFinancialProductPreferenceCoordinates(offer)
  );
};
